/**
 * Key payload BE untuk kolom CODE (barcode) di GET /list_build_item/report_builditem.
 * Header & tiap baris `ingredients[]` sama-sama memakai `product_barcode`.
 */
export const ITEM_BUILD_REPORT_BARCODE_KEYS = {
  header: "product_barcode",
  ingredient: "product_barcode",
} as const

export function formatReportBarcode(value?: string | null): string {
  const trimmed = value?.trim()
  return trimmed ? trimmed : "-"
}

/** Barcode ingredient — BE mengirim `product_barcode` di dalam objek ingredient. */
export function getIngredientReportBarcode(
  ingredient?: { product_barcode?: string | null; product_ingredient_barcode?: string | null } | null
): string {
  return formatReportBarcode(
    ingredient?.product_barcode ?? ingredient?.product_ingredient_barcode
  )
}
